import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styles from './index.module.scss';
import EfIcon from '@elem/ui/ef-icon';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoDialog from 'eco-design/base/eco-dialog';
import Image from 'next/image';
import getLocal from '@/app/utils/getLocal';

const OnlineStoreRightsA: React.FC = () => {
    const { t } = useLang('theProduct.OnlineStoreRightsA');
    const [open, setOpen] = useState<boolean>(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isMobileDevice, setIsMobileDevice] = useState<'pc' | '3h5' | '2h5'>('pc');
    const [theStoreUrl, setTheStoreUrlStoreUrl] = useState<string>('#');
    const [calcNum, setCalcNum] = useState<number>(1);
    const { locale } = getLocal();

    const storeUrl: any = useMemo(
        () => ({
            eu: {
                pcUrl: 'https://websiteoss.ecoflow.com/upload/image/1744958153395/pc-store-1-eu.png',
                mUrl3: 'https://websiteoss.ecoflow.com/upload/image/1744958397273/m-store-1-eu%403.jpg',
                mUrl2: 'https://websiteoss.ecoflow.com/upload/image/1744958398265/m-store-1-eu%402.jpg',
                modalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744545641917/pc-modal-3-eu%402.jpg',
                mModalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744545651404/m-modal-3-eu%402.jpg',
            },
            uk: {
                pcUrl: 'https://websiteoss.ecoflow.com/upload/image/1744958152789/pc-store-1-uk.png',
                mUrl3: 'https://websiteoss.ecoflow.com/upload/image/1744958398938/m-store-1-uk%403.jpg',
                mUrl2: 'https://websiteoss.ecoflow.com/upload/image/1744958399109/m-store-1-uk%402.jpg',
                modalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546727328/pc-modal-3-uk%402.jpg',
                mModalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546727144/m-modal-3-uk%402.jpg',
            },
            de: {
                pcUrl: 'https://websiteoss.ecoflow.com/upload/image/1744958152428/pc-store-1-de.png',
                mUrl3: 'https://websiteoss.ecoflow.com/upload/image/1744958397027/m-store-1-de%403.jpg',
                mUrl2: 'https://websiteoss.ecoflow.com/upload/image/1744958396452/m-store-1-de%402.jpg',
                modalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546727505/pc-modal-3-de%402.jpg',
                mModalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546726319/m-modal-3-de%402.jpg',
            },
            fr: {
                pcUrl: 'https://websiteoss.ecoflow.com/upload/image/1744958153202/pc-store-1-fr.png',
                mUrl3: 'https://websiteoss.ecoflow.com/upload/image/1744958396643/m-store-1-fr%403.jpg',
                mUrl2: 'https://websiteoss.ecoflow.com/upload/image/1744958396840/m-store-1-fr%402.jpg',
                modalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546727716/pc-modal-3-fr%402.jpg',
                mModalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744701921562/m-modal-3-fr%402.jpg',
            },
            it: {
                pcUrl: 'https://websiteoss.ecoflow.com/upload/image/1744958152626/pc-store-1-it.png',
                mUrl3: 'https://websiteoss.ecoflow.com/upload/image/1744958398455/m-store-1-it%403.jpg',
                mUrl2: 'https://websiteoss.ecoflow.com/upload/image/1744958397885/m-store-1-it%402.jpg',
                modalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546726769/pc-modal-3-it%402.jpg',
                mModalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546727915/m-modal-3-it%402.jpg',
            },
            es: {
                pcUrl: 'https://websiteoss.ecoflow.com/upload/image/1744958152999/pc-store-1-es.png',
                mUrl3: 'https://websiteoss.ecoflow.com/upload/image/1744958398090/m-store-1-es%403.jpg',
                mUrl2: 'https://websiteoss.ecoflow.com/upload/image/1744958398692/m-store-1-es%402.jpg',
                modalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546726511/pc-modal-3-es%402.jpg',
                mModalUrl: 'https://websiteoss.ecoflow.com/upload/image/1744546728134/m-modal-3-es%402.jpg',
            },
        }),
        [],
    );

    const handleClose = () => {
        setIsVisible(false);
        document.body.style.overflow = '';
        setTimeout(() => {
            setOpen(false);
        }, 300);
    };

    const handleOpen = () => {
        setOpen(true);
        setIsVisible(true);
        getCalcModalHeight();
        document.body.style.overflow = 'hidden';
    };

    const handlePrevent = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const getRightsUrl = useCallback(() => {
        if (isMobileDevice === 'pc') {
            setTheStoreUrlStoreUrl(storeUrl[locale]?.pcUrl);
        } else if (isMobileDevice === '3h5') {
            setTheStoreUrlStoreUrl(storeUrl[locale]?.mUrl3);
        } else {
            setTheStoreUrlStoreUrl(storeUrl[locale]?.mUrl2);
        }
    }, [isMobileDevice, locale, storeUrl]);

    const getCalcModalHeight = () => {
        if (window.innerWidth >= 768 && window.innerHeight <= 846) {
            setCalcNum(Math.round((window.innerHeight / 846) * 100 * 0.95) / 100);
        } else {
            setCalcNum(1);
        }
    };

    function initDevice() {
        if (typeof window !== 'undefined') {
            if (window.innerWidth >= 768) {
                setIsMobileDevice('pc');
            } else if (window.innerWidth > 430 && window.innerWidth < 768) {
                setIsMobileDevice('3h5');
            } else {
                setIsMobileDevice('2h5');
            }
        }
    }

    useEffect(() => {
        initDevice();
        typeof window !== 'undefined' && window.addEventListener('resize', initDevice);
    }, []);

    useEffect(() => {
        getRightsUrl();
    }, [isMobileDevice, locale, getRightsUrl]);

    return (
        <section className={styles.OnlineStoreRightsA}>
            <div className="title">{t('online_store_title')}</div>
            <div className="rights">
                <Image unoptimized sizes="100%" alt={t('online_store_title')} quality={100} fill={true} src={theStoreUrl} />
            </div>
            {/* <div className="condition-desc">
                <span onClick={handleOpen}>{t('online_store_terms_and')}</span>
            </div> */}
            {open && (
                <div className={`store-modal-root ${isVisible ? 'fade-in' : 'fade-out'}`} onClick={handleClose}>
                    <div
                        className={`store-modal-wrap ${isVisible ? 'popup' : 'popout'}`}
                        onClick={handlePrevent}
                        style={isMobileDevice === 'pc' ? { transform: `scale(${calcNum})` } : {}}
                    >
                        {isMobileDevice === 'pc' && <span className="close-icon" onClick={handleClose}></span>}
                        {isMobileDevice !== 'pc' && (
                            <div className="modal-title">
                                <span className="title-text">{t('online_store_terms_and')}</span>
                                <span className="title-text-icon" onClick={handleClose}>
                                    <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1744533108904/cancel.png"></EfIcon>
                                </span>
                            </div>
                        )}

                        <div className="modal-body">
                            <div className="modal-content">
                                <Image
                                    unoptimized
                                    sizes="100%"
                                    className="store-modal-image"
                                    alt={t('online_store_title')}
                                    style={{
                                        objectFit: 'contain', // 核心点：完整显示图片
                                        objectPosition: 'center',
                                    }}
                                    quality={100}
                                    fill={true}
                                    src={isMobileDevice === 'pc' ? storeUrl[locale].modalUrl : storeUrl[locale].mModalUrl}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default OnlineStoreRightsA;
